import { css } from '@linaria/core';

export const Container = css`
	display: flex;
	width: 100%;
	padding: 1.2rem;
	border-radius: var(--radius-xs);
	background-color: var(--color-white-xxs);
	gap: var(--gap-s);
`;
